export default __webpack_public_path__ + "static/media/depotimportsample.9aad7f5d.xlsx";